// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import {
    call,
    put,
    takeLatest
} from 'redux-saga/effects';

import {
    actionStatusStarted,
    actionStatusFailed,
    actionStatusSuccess,
    actionStatusAccepted,
} from './../../../store/actionStatus';

import {
    GET_WARRANTY_INFO_DATA,
    getWarrantyInfoData,
    getWarrantyInfoDataFail
} from './../../../store/deviceInfo/warranty';

import WarrantyDal from './../../../dal/WarrantyDal';

function callApiMethod(params: any) {
    const { payload } = params;
    const { body, extension } = payload;
    const { serialNumber } = body;
    if (extension.toUpperCase() === 'PROOFOFPURCHASE') {
        return WarrantyDal.postProofOfPurchaseWarrantyUpdate(body, extension, serialNumber);
    }
    return WarrantyDal.postExtensionWarrantyUpdate({ body, extension });
}

function* handleFetch(payload: any) {
    try {
        yield put(actionStatusStarted({ actionName: GET_WARRANTY_INFO_DATA }));

        const res = yield call(callApiMethod, payload);
        if (res && res.error) {
            yield put(actionStatusFailed({
                actionName: GET_WARRANTY_INFO_DATA,
                data: { ...payload.payload },
                error: res.error,
            }));
            yield put(getWarrantyInfoDataFail(res.error));
        } else {
            if (res.StatusCode === 202) {
                yield put(actionStatusAccepted({ actionName: GET_WARRANTY_INFO_DATA, data: res }));
            } else {
                yield put(actionStatusSuccess({ actionName: GET_WARRANTY_INFO_DATA, data: res }));
            }
        }
    } catch (err) {
        yield put(actionStatusFailed({
            actionName: GET_WARRANTY_INFO_DATA,
            data: { ...payload.payload },
            error: err,
        }));

        if (err instanceof Error) {
            yield put(getWarrantyInfoDataFail(err['response']));
        }
        else {
            yield put(getWarrantyInfoDataFail('An unknown error occured.'));
        }
    }
}

export default [
    takeLatest(`${getWarrantyInfoData}`, handleFetch),
];
